import React from 'react'
import  { 
    TitleSection, 
    BorderBottom, 
    Wrapps,
    More,
    SectionSKill,
  } from '../../globalStyle';
import Skill from './skill'

function SkillApp(){
    return(
        <SectionSKill id="skill">
        <TitleSection margin>Skills</TitleSection>
        <BorderBottom />
        <Wrapps>
            <Skill />
        </Wrapps>
        <More to='/skills'>Skills more</More>
    </SectionSKill>
    )
}
export default SkillApp